
export default {
  title: 'Calculator'
}
